import type { IDataFetcherFactory } from "./IDataFetcher";
import { ReduxStateAwareDataFetcher } from "./ReduxStateAwareDataFetcher";

class ConnectedAssetsDataFetcher<T> extends ReduxStateAwareDataFetcher<T> {
    fetch(params = this.widget.apiParams) {
        params.ShouldGetVerifiedData = this.reduxService.getStatePath(this.statePath);
        return super.fetch(params);
    }
}

const ConnectedAssetsDataFetcherFactory: IDataFetcherFactory<any> = {
    create: function (widget, { statePath } = {}) {
        return new ConnectedAssetsDataFetcher<any>(widget, statePath);
    },
};

export default ConnectedAssetsDataFetcherFactory;
